import { createFileRoute } from '@tanstack/react-router';
import { APP_PATHS, PAGE_PATHS, Permission, PermissionEntitiesNames } from '../../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/settings/severity/audit/$automationId/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.SEVERITY_SLA, app: APP_PATHS.THREATS }) &&
      !!context.userPermissions.hasAllowedPermissionToResource({
        resource: PermissionEntitiesNames.ACCOUNT,
        permission: Permission.UPDATE,
      });
    context.validatePermissions({ isAllowed, preload });
  },
});
